// extracted by mini-css-extract-plugin
export default {"title":"SharedLayout_title__sRyeQ","text":"SharedLayout_text__rU2gG","textDemo":"SharedLayout_textDemo__x0zBL","span":"SharedLayout_span__Twj5k"};